import React from "react";
import { Field } from "formik";
import { Alert, Input } from "components/bootstrap";
import { Link, Spinner } from "components/common";
import AppConfig from "util/AppConfig";
import DataTieringRoutes from "./Routes";
import { STORAGE_REPOSITORY_TYPE_LABELS } from "./repository-management/types";
import useRepositories from "./repository-management/hooks/useRepositories";
import RepositorySelect from "./repository-management/RepositorySelect";
const RepositoryManagement = ({
  valuesPrefix = void 0,
  disabled = false,
  fieldName: fieldNameProp = void 0,
  type = void 0,
  types = void 0,
  layout = "vertical",
  label = "Repository",
  help = "Which warm storage repository should this index set be stored in"
}) => {
  const isCloud = AppConfig.isCloud();
  const isHorizontal = layout === "horizontal";
  const typeFilter = types != null ? types : type;
  const { repositories } = useRepositories(typeFilter);
  const typePrefix = type ? `${STORAGE_REPOSITORY_TYPE_LABELS[type]} ` : "";
  const resolvedFieldName = fieldNameProp != null ? fieldNameProp : valuesPrefix ? `${valuesPrefix}.data_tiering.warm_tier_repository_name` : "data_tiering.warm_tier_repository_name";
  const renderContent = () => {
    var _a, _b;
    if (repositories.isLoading) {
      return /* @__PURE__ */ React.createElement(Spinner, { text: "Fetching Warm Storage Repositories..." });
    }
    if (((_b = (_a = repositories.data) == null ? void 0 : _a.length) != null ? _b : 0) === 0) {
      return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, `No ${typePrefix}Warm Storage Repositories exist yet.`, " ", isCloud ? "Repositories can be created through the API." : /* @__PURE__ */ React.createElement(React.Fragment, null, "Create one on the ", /* @__PURE__ */ React.createElement(Link, { to: DataTieringRoutes.WARM_TIER_REPOSITORIES }, "Warm Tier Repositories page"), "."));
    }
    return /* @__PURE__ */ React.createElement(RepositorySelect, { disabled, fieldName: resolvedFieldName, type: typeFilter });
  };
  return /* @__PURE__ */ React.createElement(Field, { name: resolvedFieldName }, ({ meta: { error, touched } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      bsStyle: error && touched ? "error" : void 0,
      help,
      error: touched ? error : void 0,
      id: "default-roles-select",
      label,
      labelClassName: isHorizontal ? "col-sm-3" : void 0,
      wrapperClassName: isHorizontal ? "col-sm-9" : void 0
    },
    renderContent()
  ));
};
export default RepositoryManagement;
